@if (eStatus.phase !== 'post-live' && eStatus.user_ask_questions) {
  <div
    class="hr_collapsible_uaq"
    (click)="toggleUserQuestions()"
    >
    <button type="button" class="hr_btn_collapsible">
      <span
      [ngClass]="{
        active: this.showQuestionForm == 'in'
      }"
        class="arrow"
        >
        <span></span>
        <span></span>
      </span>
      <span
        >{{ eLangGlob.translateYour }} {{ eLangGlob.translateQuestionsFixed }}</span
        >
      </button>
    </div>
  }
  @if (eStatus.user_ask_questions) {
    <div
      class="hr_collapsed_uaq"
      [@slideInOut]="showQuestionForm"
      >
      <div style="margin-top: 20px">
        @if (eStatus) {
          <div>
            <form
              style="max-width: 560px; display: block"
              name="form"
              (ngSubmit)="onSubmit()"
              #f="ngForm"
              ngNativeValidate
              >
              <span>{{ eLangGlob.translateUaqHeadlineLabel }}</span>
              <div class="hr_uaq_grid">
                @if (eStatus.name) {
                  <label
                    class="hr_lbl_author"
                    for="author">
                    {{ eLangGlob.translateNameLabel }}
                  </label>
                }
                @if (eStatus.name && !eStatus.nameReq) {
                  <input
                    class="hr_uaq_textbox hr_uaq_input_author"
                    type="text"
                    name="author"
                    [(ngModel)]="form.author"
                    #author="ngModel"
                    />
                }
                @if (eStatus.name && eStatus.nameReq) {
                  <input
                    class="hr_uaq_textbox hr_uaq_input_author"
                    type="text"
                    name="author"
                    [(ngModel)]="form.author"
                    required
                    #author="ngModel"
                    />
                }
                @if (eStatus.additional) {
                  <label
                    class="hr_lbl_location"
                    for="location"
                    >
                    {{ eLangGlob.translateAdditionalLabel }}
                  </label>
                }
                @if (eStatus.additional && eStatus.additional_req) {
                  <input
                    class="hr_uaq_textbox hr_uaq_input_location"
                    type="text"
                    name="location"
                    [(ngModel)]="form.location"
                    required
                    #location="ngModel"
                    />
                }
                @if (eStatus.additional && !eStatus.additional_req) {
                  <input
                    class="hr_uaq_textbox hr_uaq_input_location"
                    type="text"
                    name="location"
                    [(ngModel)]="form.location"
                    #location="ngModel"
                    />
                }
                <label class="hr_lbl_message" for="msgText">
                  {{ eLangGlob.translateMsgLabel }}
                </label>
                <div class="hr_uaq_text_message hr_uaq_message_wrap">
                  <textarea
                    class="hr_uaq_textbox"
                    type="text"
                    name="msgText"
                    [(ngModel)]="form.msgText"
                    required
                    minlength="1"
                    [attr.maxlength]="charLimit"
                    #msgText="ngModel"
                  ></textarea>
                  @if (charLimit !== null) {
                    <span class="hr_uaq_charcount" aria-live="polite">
                      {{ form.msgText?.length || 0 }} / {{ charLimit }}
                    </span>
                  }
                </div>
                <span class="uaq_button_left"></span>
                <button
                  [disabled]="showHint"
                  class="hr_uaq_grid_submit hr_uaq_grid_button"
                  >
                  {{ eLangGlob.translateSendBtn }}
                </button>
                <span class="uaq_button_right"></span>
              </div>
              <div>
                @if (f.submitted && showHint) {
                  <div
                    class="ui visible warning message"
                    role="alert"
                    style="margin-top: 20px"
                    >
                    {{ hintText }}
                  </div>
                }
              </div>
              @if (!this.eConfig.customPolicyAdditional_enabled && !this.eConfig.customPolicyName_enabled && !this.eConfig.customPolicyMessage_enabled) {
                <p class="privacy_policy">{{ eLangGlob.translatePolicy }}</p>
              }
              @if (this.eConfig.customPolicyName_enabled) {
                <p class="privacy_policy">{{ eLangGlob.translatePolicyName }}</p>
              }
              @if (this.eConfig.customPolicyAdditional_enabled && this.eStatus.additional) {
                <p class="privacy_policy">{{ eLangGlob.translatePolicyAdditional }}</p>
              }
              @if (this.eConfig.customPolicyMessage_enabled) {
                <p class="privacy_policy">{{ eLangGlob.translatePolicyMessage }}</p>
              }
            </form>
          </div>
        }
      </div>
    </div>
  }
  @if (eStatus.phase !== 'post-live' && eStatus.user_ask_questions) {
    <hr />
  }
